import React from 'react';
import { Row, Col } from 'reactstrap';
import AgentIndicators from '../../AgentIndicators';
import CollectiveIndicators from '../../CollectiveIndicators';

const TelephonyTab = ({ agent, extension, dashboardChatIndividually }) => {
  return (
    <Row>
      <Col xl="6">
        <AgentIndicators
          agent={agent}
          extension={extension}
          dashboardChatIndividually={dashboardChatIndividually}
        />
      </Col>
      <Col xl="6">
        <CollectiveIndicators />
      </Col>
    </Row>
  );
};

export default TelephonyTab;
